<div class="header-container">
    <div class="logo-container">
        <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
            <nb-icon icon="menu-2-outline"></nb-icon>
        </a>
        <a class="logo" href="#" (click)="navigateHome()">
            <span><img src="{{logo}}" height="32" width="auto" style="margin-right: 10px;" /></span>

        </a>

    </div>
    <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
</div>

<div class="header-container overflow">

    <nb-actions size="small">

        <!-- Spotlight Search Input -->
        <nb-action class="spotlight-action" >
            <div class="spotlight-input-wrapper" (click)="openSpotlight()" title="Quick search (⌘K)">
                <nb-icon icon="search-outline" class="search-icon"></nb-icon>
                <input 
                    type="text" 
                    class="spotlight-input" 
                    placeholder="Search..."
                    readonly
                />
                <span class="spotlight-shortcut">⌘K</span>
            </div>
        </nb-action>

        <!-- <nb-action>
      <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
        <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
      </nb-select>
    </nb-action> -->
        <nb-action *ngIf="activeusername!==null" (dblclick)="handleUserLogout()" [nbTooltip]="doubleClickToLogoutTooltip" nbTooltipPlacement="bottom" >
            <span >
                <nb-icon icon="person-outline" class="userico"></nb-icon> {{activeusername}}
            </span>
        </nb-action>

        <nb-action class="lang-action">
            <div class="lang-switcher-header">
                <span class="lang-label">🌐</span>
                <app-language-selector></app-language-selector>
            </div>

            <div class="sync">

                <div class="syncstatus">
                    <div class="status-label">{{sync_status}}</div>
                    <div class="status-time">{{updated_time|date:'short'}}</div>
                </div>
                <div [nbSpinner]="loading||loading1" nbSpinnerStatus="success" (click)="forcePush()">
                    <span [title]="'header.syncDataToPos' | translate" style="cursor: pointer; color: white!important;" >
                        <nb-icon icon="sync-outline" [options]="{ animation: { type: 'pulse' } }"></nb-icon>
                    </span>
                </div>
            </div>
            <div class="internet">
                <nb-icon [title]="'header.internetAvailable' | translate" *ngIf="internetStatus" icon="wifi-outline" style="color: green !important;" [options]="{ animation: { type: 'pulse' } }"></nb-icon>
                <nb-icon [title]="'header.internetNotAvailable' | translate" *ngIf="!internetStatus" icon="wifi-off-outline" style="color: red !important;" [options]="{ animation: { type: 'pulse' } }"></nb-icon>
            </div>
        </nb-action>


        <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action>
    <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action> -->
        <!-- Notifications (commented until backend is ready - uncomment and wire to API) -->
        <!-- <nb-action class="notification-action">
            <span class="notification-trigger" [nbPopover]="notificationPopoverTpl" nbPopoverPlacement="bottom" nbPopoverTrigger="click">
                <nb-icon icon="bell-outline" class="notification-icon"></nb-icon>
                <span class="notification-badge" *ngIf="notificationUnreadCount > 0">{{ notificationUnreadCount > 99 ? '99+' : notificationUnreadCount }}</span>
            </span>
        </nb-action>

        <ng-template #notificationPopoverTpl>
            <div class="notification-popover">
                <div class="notification-popover-header">
                    <span class="notification-popover-title">Notifications</span>
                    <span class="notification-popover-count" *ngIf="notificationUnreadCount > 0">{{ notificationUnreadCount }} unread</span>
                </div>
                <div class="notification-popover-list">
                    <div *ngFor="let item of notificationsSlice" class="notification-popover-item" [class.unread]="!item.read">
                        <div class="notification-popover-item-content">
                            <span class="notification-popover-item-title">{{ item.title }}</span>
                            <span class="notification-popover-item-message">{{ item.message }}</span>
                            <span class="notification-popover-item-time">{{ item.time | date:'short' }}</span>
                        </div>
                    </div>
                    <div *ngIf="notifications.length === 0" class="notification-popover-empty">No notifications yet.</div>
                </div>
                <div class="notification-popover-footer">
                    <a routerLink="/pages/notifications" class="notification-view-all">View all notifications</a>
                </div>
            </div>
        </ng-template> -->

        <nb-action class="user-action" *nbIsGranted="['view', 'user']">
            <nb-user [nbContextMenu]="userMenu" [onlyPicture]="false" [name]="user?.name" [picture]="user?.picture">
            </nb-user>
        </nb-action>
    </nb-actions>
</div>
<style>
.lang-switcher-header {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  padding: 4px 12px;
  margin-left: 12px;
  margin-right: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.lang-label {
  font-size: 1.1rem;
  margin-right: 8px;
  opacity: 0.8;
}
.lang-select {
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 1rem;
  background: #f9f9f9;
  color: #333;
}

/* Ensure the language selector is visible */
.lang-switcher-header app-language-selector {
  display: block;
}

.lang-switcher-header .language-selector {
  display: block !important;
}

.lang-switcher-header .language-select {
  display: block !important;
  min-width: 100px;
}

/* Hide language switcher header on mobile screens */
@media screen and (max-width: 576px) {
  .lang-switcher-header {
    display: none !important;
  }
}

/* Spotlight search input styles */
.spotlight-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 250px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.spotlight-input-wrapper:hover {
  border-color: #b0b0b0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.spotlight-input-wrapper:focus-within {
  border-color: #3366ff;
  box-shadow: 0 0 0 3px rgba(51, 102, 255, 0.1);
}

.spotlight-input-wrapper .search-icon {
  font-size: 18px;
  color: #666!important;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spotlight-input-wrapper nb-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.spotlight-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  padding: 0;
}

.spotlight-input::placeholder {
  color: #999;
}

.spotlight-shortcut {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  color: #666!important;
  font-family: monospace;
  flex-shrink: 0;
}

/* Tablet and below - hide shortcut, reduce width */
@media screen and (max-width: 768px) {
  .spotlight-input-wrapper {
    min-width: 180px;
  }
  .spotlight-shortcut {
    display: none;
  }
}

/* Small tablets - further reduce size */
@media screen and (max-width: 640px) {
  .spotlight-input-wrapper {
    min-width: 140px;
    padding: 6px 10px;
    gap: 6px;
  }
  .spotlight-input {
    font-size: 13px;
  }
}

/* Mobile screens - collapse to icon only */
@media screen and (max-width: 480px) {
  .spotlight-input-wrapper {
    min-width: unset;
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 50%;
    gap: 0;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid #d0d0d0;
  }
  
  .spotlight-input-wrapper:hover {
    background: rgba(255, 255, 255, 1);
    border-color: #999;
  }
  
  .spotlight-input-wrapper .search-icon {
    font-size: 22px !important;
    color: #333 !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    margin: 0 !important;
  }
  
  .spotlight-input-wrapper nb-icon {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  
  .spotlight-input {
    display: none !important;
  }
  
  .spotlight-shortcut {
    display: none !important;
  }
}

/* Extra small screens - ensure proper spacing */
@media screen and (max-width: 360px) {
  .spotlight-input-wrapper {
    width: 36px;
    height: 36px;
  }
  
  .spotlight-input-wrapper .search-icon {
    font-size: 20px !important;
  }
  
  .spotlight-action {
    margin-right: 0 !important;
  }
}
</style>